// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__ve5C6","label":"styles_label__jI10P","caption":"styles_caption__hWnxQ","description":"styles_description__h0FwK","content":"styles_content__M6pjv"};